module.exports = __webpack_public_path__ + "img/cgsp1.dd9e673b.png";